import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';
import { ControlProps } from '../Control';

export const useStyles = ({ isDisabled }: Pick<ControlProps, 'isDisabled'>) => {
  const styles = useStyleSheet(
    (theme) => ({
      root: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.secondary,
        paddingRight: '0.1rem',
        '& > div': {
          padding: 0,
          margin: 0,
          '& > svg': {
            color: isDisabled ? `rgba(0, 0, 0, .2) !important` : undefined,
          },
        },
      },
    }),
    [isDisabled],
  );

  return styles;
};
